import { createMachine, assign } from "xstate";

const setWards = assign({
  wards: (context, event) => {
    return event.wards ?? []
  }
})

const setLoggedInGuardian = assign({
    loggedInGuardian: (context, event) => {
        return event.guardian;
    }
})

const addWard = assign({
  wards: (context, event) => {
    return [...context.wards, event.ward]
  }
})

const removeWardAtIndex = assign({
    wards: (context, event) => {
      return context.wards.filter((_, index) => index !== event.index)
    }
})

const hasNoWards = (context, _) => {
  return context.wards.length === 0
}

const hasOneWard = (context, _) => {
  return context.wards.length === 1
}

const hasWards = (context, _) => {
  return context.wards.length > 0
}

const followGuardianRedirect = (context, event) => {
  window.location = event.guardian.redirect_url
}

const redirectToSignIn = (c, e) => {
  // Ideally we pass the URL to state machine and let it redirect
  // but we don't have a way to do that yet
  document.location.href="/"
}

const showExistingGuardianList = (context, _) => {
    return !context.loggedInGuardian && context.wards.find(ward => ward.guardians.length > 0)
}

export const machine = createMachine(
  {
    initial: "beforeInitialized",
    predictableActionArguments: true,
    preserveActionOrder: true,
    context: {
      wards: [],
      loggedInGuardian: null,
    },
    states: {
      beforeInitialized: {
        on: {
          INITIALIZE: {
            actions: ['setWards','setLoggedInGuardian'],
            target: "initialized",
          }
        }
      },
      initialized: {
        always: [
          {
            target: "wardList",
            cond: 'hasWards',
          },
          {
            target: "magicCodeForm",
            cond: 'hasNoWards',
          },
        ]
      },
      wardList: {
        on: {
          ADD_WARD: {
            target: "magicCodeForm",
          },
          REMOVE_WARD: [
            {
              cond: 'hasOneWard',
              actions: ['removeWardAtIndex'],
              target: "magicCodeForm",
            },
            {
              actions: ['removeWardAtIndex'],
              target: "wardList",
            }
          ],
          GUARDIAN_UPDATED: {
            actions: ['followGuardianRedirect'],
            target: 'wardList',
          },
          NEXT: [
            {
              target: "existingGuardianList",
              cond: 'showExistingGuardianList',
            },
            {
              target: "guardianForm",
              cond: 'hasWards'
            },
          ]
        }
      },
      magicCodeForm: {
        on: {
          WARD_ADDED: {
            actions: ['addWard'],
            target: "wardList",
          },
          REMOVE_WARD: {
            actions: ['removeWardAtIndex'],
            target: "magicCodeForm",
          },
          BACK: {
            target: "wardList",
          },
        }
      },
      existingGuardianList: {
        on: {
          NEXT: {
            target: "guardianForm",
          },
          BACK: {
            target: "wardList",
          },
          SIGN_IN: {
            actions: ['redirectToSignIn'],
          }
        }
      },
      guardianForm: {
        on: {
          GUARDIAN_CREATED: {
            actions: ['followGuardianRedirect'],
            target: "guardianForm",
          },
          BACK: [
            {
              cond: "showExistingGuardianList",
              target: "existingGuardianList",
            },
            {
              target: "wardList",
            }
          ]
        }
      },
      submitted: {},
      error: {},
    },
  },
  {
    actions: {
      setWards,
      setLoggedInGuardian,
      addWard,
      removeWardAtIndex,
      followGuardianRedirect,
      redirectToSignIn
    },
    guards: {
      showExistingGuardianList,
      hasOneWard,
      hasWards,
      hasNoWards,
    }
  }
)